export class Scheduler {

    public project_device_assignement: number;
    public start_date: string;
    public end_date: string;
    public status: string;


}
